<template>
  <div :class="classes()">
    <div :class="`${el}__top`">
      <Icon
        v-if="$matchMedia.l || !text"
        :class="`${el}__icon`"
        :name="iconName"
        size="l"
        :color="background === 'secondaryYellow' ? 'tertiaryDark' : 'primaryBlue'"
      />
      <Copy
        v-if="headline"
        :color="background === 'secondaryMintLight' ? 'primaryBlue' : 'tertiaryDark'"
        element="div"
        bold
      >
        {{ headline }}
      </Copy>
    </div>
    <template v-if="$slots.text">
      <slot name="text" />
    </template>
    <Copy v-else element="div">
      {{ text }}
    </Copy>
    <Link
      v-if="link"
      :class="`${el}__link`"
      :to="link.href"
      :external="link.external"
      :onClick="link.onClick"
    >
      {{ link.text }}
    </Link>
  </div>
</template>

<script>
import Icon from '@/objects/Icon';
import Copy from '@/objects/Copy';
import Link from '@/objects/Link';

import { IconNameTypes } from '@/constants/enums';

export default {
  name: 'Alert',
  props: {
    headline: String,
    text: String,
    iconName: {
      type: String,
      default: 'information-line',
      validator: (val) => IconNameTypes.includes(val),
    },
    background: {
      type: String,
      default: 'secondaryRoseLighter',
      validator: (val) =>
        ['secondaryRoseLighter', 'secondaryYellow', 'secondaryMintLight'].includes(val),
    },
    link: {
      text: String,
      href: String,
      external: {
        type: Boolean,
        default: false,
      },
    },
  },
  components: {
    Icon,
    Copy,
    Link,
  },
  data() {
    return {
      el: 'o-alert',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--${this.background}`]: true,
          [`${el}--iconTop`]: !this.text,
        };
      },
    };
  },
};
</script>
